import React from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import ContentWrapper from "styles/contentWrapper"

const bgImg = "https://hrflow-ai.imgix.net/featured-bg.png"
const sspotl = "https://hrflow-ai.imgix.net/backgrounds/sspotl.svg"
const bspotl = "https://hrflow-ai.imgix.net/backgrounds/bspotl.svg"
const sspotr = "https://hrflow-ai.imgix.net/backgrounds/sspotr.svg"
const bspotr = "https://hrflow-ai.imgix.net/backgrounds/bspotr.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  padding: 12rem 0;
  position: relative;
  background-image: url(${sspotl}), url(${bspotl}), url(${sspotr}), url(${bspotr}), url(${bgImg});
  background-repeat: no-repeat;
  background-size: 2.8rem 3.35rem, 22.95rem 37.7rem, 3.35rem 3.9rem, 24.85rem 34.8rem, 100% 100%;
  background-position: 13% 94%, -17% 112%, 86% 16%, 107% 13%, center;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 9rem 0;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

const StyledInner = styled.div`
  z-index: 1;
  color: white;
  .section-title {
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    margin-top: 0;
    margin-bottom: 1rem;
    padding: 0 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      padding-right: 0;
      padding-left: 0;
    }
  }
`

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column
  align-items: center;
  margin-top: 3rem;
  flex-wrap: wrap;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
   flex-direction: row;
   justify-content: space-between;
  }
  .item {
    display: flex;
    margin: 1rem;
    flex-direction: column;
    align-items: center;
    border-radius: 2rem;
    background: white;
    padding: 3rem 1rem;
    width: 23rem;
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
    .logo-wrapper {
      border: 2px solid #00a6c4;
      border-radius: 50%;
      height: 100px;
      width: 100px;
      margin-bottom: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    h3 {
      margin-bottom: 1rem;
    }
  }
`

const Featured = ({ content }) => {
  const { frontmatter, exports } = content[0].node
  const { items } = exports

  return (
    <StyledSection id="featured">
      <StyledContentWrapper>
        <StyledInner>
          <h2 className="section-title">{frontmatter.title}</h2>
          <StyledContent>
              {items.map(({ title, description, logo }, key) => {
                
                return (
                  <div className="item" key={key}>
                    <div className="logo-wrapper">
                      <GatsbyImage image={getImage(logo)} alt={title} />
                    </div>
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                )
              })}
          </StyledContent>
        </StyledInner>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default Featured